/* eslint-disable complexity */
// Copyright (c) 2017 Deere & Company

import React, {Component, PropTypes} from 'react';
import {
    filterCollection,
    sortCollection
} from '../../../shared/services/collections';
import {Checkbox} from 'cap-it-ui.toggles';
import {FormattedMessage} from 'react-intl';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import ListViewShowMore from '../../../product/dealer-recommendations/components/list-view-show-more';
import RefinableListWidgetWithExport from '../../../shared/components/refinable-list-widget/refinable-list-widget-with-export';
import RgaResultListItem from './rga-list-item';
import RgaSearchModel from '../../search/state/rga-search-model';
import RgaSearchResults from '../state/rga-search-result';
import SearchFilters from '../../../shared/state/search-filters';
import {rgaListFilterOptions} from '../helpers/rga-list-filter-options';
import {rgaListSortOptions} from '../helpers/rga-list-sort-options';

class RgaResultList extends Component {
    constructor(props) {

        super(props);

        this.handleFilterByChange = this.handleFilterByChange.bind(this);
        this.handleSortByChange = this.handleSortByChange.bind(this);
        this.handleSortDirectionChange = this.handleSortDirectionChange.bind(this);
        this.handleExportExcelSearchResult = this.handleExportExcelSearchResult.bind(this);

        this.state = {
            isSelectedAllRga: true,
            rgaNumbersList: []
        };

    }

    handleFilterByChange(filterText) {

        this.props.actions.updateFilterBy(filterText);

    }

    handleSortByChange(option) {

        if (option !== this.props.searchFilters.sortBy[0]) {

            this.props.actions.updateSortBy(option);

        }

    }

    handleSortDirectionChange(sortDirection) {

        this.props.actions.updateSortDirection(sortDirection);

    }

    handleExportExcelSearchResult() {

        this.props.actions.getRgaCollections(this.props.rgaSearchModel, 'EXCEL', false, this.props.currentPage);

    }

    handleMassUpdateRequest() {

        this.props.actions.setSelectedRga(this.state.rgaNumbersList);
        this.props.actions.onMassUpdateRequest();

    }

    addAllRgaToSelected = () => {

        if (this.state.isSelectedAllRga) {

            this.props.rgaList.forEach(item => {

                if (!this.state.rgaNumbersList.includes(item)) {

                    this.setState(prevState => ({
                        rgaNumbersList: [...prevState.rgaNumbersList, item]
                    }));

                }

            });

        } else {

            // Deselect all RGA numbers

            this.setState(() => ({

                rgaNumbersList: []
            }));

        }
        this.setState(prevState => ({

            isSelectedAllRga: !prevState.isSelectedAllRga
        }));

    }

    handleSelectRga(selectedRga, isSelected) {

        if (isSelected) {

            this.setState(prevState => ({
                rgaNumbersList: [...prevState.rgaNumbersList, selectedRga]
            }));

        } else {

            this.setState(prevState => ({
                rgaNumbersList: prevState.rgaNumbersList.filter(rga => rga !== selectedRga)
            }));

        }

    }

    render() {

        const {rgaList, searchFilters, parenpropsLocation, actions, infoReqStatus, partReqStatus, photoReqStatus} = this.props;

        let sortedCollection;

        sortedCollection = sortCollection(searchFilters.sortBy, searchFilters.sortDirection, [...rgaList]);
        sortedCollection = filterCollection(searchFilters.filterBy, rgaListFilterOptions, sortedCollection);

        return (
            <div className='rga-result'>
                <RefinableListWidgetWithExport
                    hasResults={rgaList.length > 0}
                    onExport={this.handleExportExcelSearchResult}
                    onFilterByChange={this.handleFilterByChange}
                    onSortByChange={this.handleSortByChange}
                    onSortDirectionChange={this.handleSortDirectionChange}
                    searchFilters={searchFilters}
                    sortOptions={rgaListSortOptions}
                />
                {sortedCollection.length && parenpropsLocation && parenpropsLocation.pathname && parenpropsLocation.pathname.includes('mass-update') ? (
                    <section className='button-group mass-update-button'>
                        <button
                            className='primary'
                            onClick={this.handleMassUpdateRequest.bind(this)}
                        >
                            <FormattedMessage id='Mass Update'/>
                        </button>
                    </section>
                ) : ''}
                {sortedCollection.length && parenpropsLocation && parenpropsLocation.pathname && parenpropsLocation.pathname.includes('mass-update') ? (
                    <Checkbox
                        id={!this.state.isSelectedAllRga}
                        onChange={this.addAllRgaToSelected.bind(this)}
                        selected={!this.state.isSelectedAllRga}
                    >{this.state.isSelectedAllRga ? <FormattedMessage id='SELECT_ALL'/> : <FormattedMessage id='DESELECT_ALL'/>}</Checkbox>
                ) : ''}
                {sortedCollection.length ? (

                    <ListViewShowMore
                        handleMore={this.props.handleMore}
                        totalItems={this.props.totalElements}
                        totalPages={this.props.totalPages}
                    >
                        {sortedCollection.map(item => (
                            <RgaResultListItem
                                actions={actions}
                                currentPage={this.props.currentPage}
                                infoReqStatus={infoReqStatus}
                                item={item}
                                key={item.rgaNumber}
                                onSelectRga={this.handleSelectRga.bind(this)}
                                parenpropsLocation={parenpropsLocation}
                                partReqStatus={partReqStatus}
                                photoReqStatus={photoReqStatus}
                                rgaNumbersList={this.state.rgaNumbersList}
                            />
                        ))}
                    </ListViewShowMore>
                ) : (
                    <FormattedMessage id='NO_RESULTS_FOUND'/>
                )}
            </div>
        );

    }
}

RgaResultList.displayName = 'RgaResultList';
RgaResultList.propTypes = {
    actions: PropTypes.object.isRequired,
    currentPage: PropTypes.number.isRequired,
    handleMore: PropTypes.func.isRequired,
    infoReqStatus: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    parenpropsLocation: PropTypes.object.isRequired,
    partReqStatus: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    photoReqStatus: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    rgaList: PropTypes.arrayOf(PropTypes.instanceOf(RgaSearchResults)).isRequired,
    rgaSearchModel: PropTypes.arrayOf(PropTypes.instanceOf(RgaSearchModel)).isRequired,
    searchFilters: PropTypes.instanceOf(SearchFilters).isRequired,
    totalElements: PropTypes.object.isRequired,
    totalPages: PropTypes.object.isRequired
};

export default RgaResultList;



// WEBPACK FOOTER //
// ./src/rga/rga-search-results/components/rga-result-list.js